import { HttpService } from "./http.service";

const basePath = "/PickupStatus";
const request = HttpService.handleRequest();

export const PickupStatusService = {
  getAll
};

async function getAll() {
  return request.get(basePath);
}

export default PickupStatusService;